import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AiClientService {

  private _isAIOrg$ = new BehaviorSubject<boolean>(this.getInitialState());
  public isAIOrg$: Observable<boolean> = this._isAIOrg$.asObservable();

  private _isAIClient$ = new BehaviorSubject<boolean>(this.getInitialState());
  public isAIClient$: Observable<boolean> = this._isAIOrg$.asObservable();

  constructor(@Inject(DOCUMENT) private document: any) {}

  get isAIOrg(): boolean {
    return this._isAIOrg$.value;
  }

  setAIClientStatus(status: boolean): void {
    localStorage.setItem('isAIClient', String(status));
    this._isAIClient$.next(status);
  }

  get isAIClient(): boolean {
    return this._isAIClient$.value;
  }

  setAIOrgStatus(status: boolean): void {
    localStorage.setItem('isAIOrg', String(status));
    this._isAIOrg$.next(status);
  }

  private getInitialState(): boolean {
    return localStorage.getItem('isAIOrg') === 'true';
  }

}
